/** Tool names the server's outfitter assistant agent can invoke. */
export const ASSISTANT_TOOL_NAMES = {
    NAVIGATE_TO_PAGE: "NAVIGATE_TO_PAGE",
    CREATE_MESSAGE_TEMPLATE: "CREATE_MESSAGE_TEMPLATE",
    EDIT_EMAIL_TEMPLATE: "EDIT_EMAIL_TEMPLATE",
    PREPARE_OUTFITTER_FORM: "PREPARE_OUTFITTER_FORM",
    PREPARE_CONTACT_IMPORT: "PREPARE_CONTACT_IMPORT",
    EXECUTE_PREPARED_CONTACT_IMPORT: "EXECUTE_PREPARED_CONTACT_IMPORT",
    REQUEST_SELECTION: "REQUEST_SELECTION",
    PRESENT_CHART: "PRESENT_CHART",
    PRESENT_PLAN: "PRESENT_PLAN",
} as const

/** Discriminator on tool outputs so we can branch on shape at runtime. */
export const ASSISTANT_TOOL_OUTPUT_TYPES = {
    NAVIGATION: "navigation",
    MESSAGE_TEMPLATE_CREATE: "message_template_create",
    EMAIL_TEMPLATE_EDIT: "email_template_edit",
    OUTFITTER_FORM_PREPARE: "outfitter_form_prepare",
    CONTACT_IMPORT_PREPARE: "contact_import_prepare",
    CONTACT_IMPORT_EXECUTE: "contact_import_execute",
    USER_SELECTION: "user_selection",
    CHART: "chart",
    PLAN_PROGRESS: "plan_progress",
} as const

/**
 * Canonical client-side status for a single plan step. Server payloads use a
 * looser vocabulary (e.g. "active", "done") which the parser maps onto these.
 */
export const ASSISTANT_PLAN_STEP_STATUSES = {
    PENDING: "pending",
    IN_PROGRESS: "in_progress",
    COMPLETED: "completed",
} as const

/** Server-emitted status for tool outputs that carry a status field. */
export const ASSISTANT_TOOL_OUTPUT_STATUSES = {
    SUCCESS: "success",
    ERROR: "error",
    NEEDS_CLIENT_EXECUTION: "needs_client_execution",
    NEEDS_USER_INPUT: "needs_user_input",
} as const
